export default __webpack_public_path__ + "static/media/fx-grain.74ca4a99.svg";